/**
 * A freshly issued interview link. Shown once and never stored - the token in it
 * is the credential for the interview - so losing it means issuing another.
 */
export function InviteLink({ url }: { url: string }) {
  return (
    <div className="notice stack">
      <strong>Interview link — copy it now, it is not shown again.</strong>
      <input readOnly aria-label="Interview link" value={url} onFocus={(e) => e.currentTarget.select()} />
      <div className="row">
        <button type="button" className="secondary" onClick={() => void navigator.clipboard.writeText(url)}>
          Copy link
        </button>
        <span className="small muted">Send this to the candidate. It works once.</span>
      </div>
    </div>
  );
}
